export default class Locale_EntityPropertySelector {
	NotSelected: string = "Not selected";
}